import { useState, useEffect, useCallback } from "react";
import { getToken, fetchMe, logout as apiLogout } from "../lib/api";

// Gère l'état d'authentification global de l'app.
// - Au démarrage : si un token existe, on vérifie qu'il est valide (fetchMe).
// - status: "loading" | "authenticated" | "anonymous"
export function useAuth() {
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setStatus("anonymous");
      return;
    }
    // Un token existe : on vérifie sa validité auprès du backend. fetchMe()
    // retombe déjà sur un profil mis en cache si le réseau est injoignable
    // (cf. lib/api.js) — donc si .catch() est quand même atteint ici, c'est
    // soit un vrai rejet serveur (401 : token révoqué/expiré), soit une
    // toute première ouverture hors ligne sans aucun cache. Seul le premier
    // cas justifie une vraie déconnexion : couper l'accès aux données déjà
    // en cache local à cause d'un simple souci réseau casserait le mode
    // hors ligne (étape 2) dès le démarrage à froid sans connexion.
    fetchMe()
      .then((me) => {
        setUser(me);
        setStatus("authenticated");
      })
      .catch((err) => {
        if (err?.response) {
          apiLogout();
          setStatus("anonymous");
        } else {
          setUser(null);
          setStatus("authenticated");
        }
      });
  }, []);

  const onLoggedIn = useCallback((loginData) => {
    // Après un login réussi, on récupère le profil complet
    fetchMe()
      .then((me) => {
        setUser(me);
        setStatus("authenticated");
      })
      .catch(() => {
        // fallback : au minimum le username renvoyé par login
        setUser({ username: loginData.username });
        setStatus("authenticated");
      });
  }, []);

  const logout = useCallback(() => {
    apiLogout();
    setUser(null);
    setStatus("anonymous");
  }, []);

  return { user, status, onLoggedIn, logout };
}
